<template>
  <b-modal
    ref="refModal"
    id="post-attachments-modal"
    title="Post Attach Files"
    ok-title="Upload"
    no-close-on-backdrop
    cancel-variant="outline-secondary"
    @ok="validateForm"
  >
    <validation-observer ref="postAttachmentsForm">
      <b-form id="add-post-attachments">
        <validation-provider
          #default="{ errors }"
          name="Upload Files"
          rules="required"
        >
          <b-form-group
            label="Upload Files"
            label-for="post-attachments"
          >
            <b-form-file
              id="post-attachments"
              name="post-attachments"
              :state="errors.length > 0 ? false : null"
              placeholder="Choose a file or drop it here..."
              drop-placeholder="Drop file here..."
              multiple
              v-model="postAttachments"
            />
            <small class="text-danger">{{ errors[0] }}</small>
          </b-form-group>
        </validation-provider>
      </b-form>
    </validation-observer>
  </b-modal>
</template>

<script>
import { BButton, BForm, BFormGroup, BFormFile } from 'bootstrap-vue';
import { computed, ref } from "@vue/composition-api";
import { required } from '@validations';
import { ValidationProvider, ValidationObserver } from 'vee-validate';
import usePostAttachment from '@/modules/post/composables/usePostAttachment';
import vSelect from 'vue-select';
import store from '@/store';

export default {
  setup() {
    const { getPostAttachments, uploadPostAttachments } = usePostAttachment();

    const postAttachmentsForm = ref(null);
    const refModal = ref(null);
    const postAttachments = ref([]);
    const postId = computed(() => store.getters['post/post'].id);

    const validateForm = (modalEvt) => {
      modalEvt.preventDefault();

      postAttachmentsForm.value.validate().then(async (valid) => {
        if (!valid) return;

        const response = await uploadPostAttachments(postId.value, postAttachments.value);
        if (response !== null) await getPostAttachments(postId.value);
        refModal.value.hide();
      });
    };

    return {
      // Reactive
      postAttachmentsForm,
      postAttachments,
      refModal,

      // Method
      validateForm,

      // Validator
      required
    };
  },
  components: {
    BButton,
    BForm,
    BFormGroup,
    BFormFile,
    ValidationObserver,
    ValidationProvider,
    vSelect,
  }
};
</script>

<style lang="scss">
@import '@core/scss/vue/libs/vue-select.scss';

#add-post-attachments {
  .vs__dropdown-menu {
    max-height: 200px !important;
  }
}
</style>